export const getGoogleLoginState = (currentUrl: string, redirectURI?: string): string => {
  if (redirectURI) return btoa(redirectURI);
  if (!new URL(currentUrl).pathname.startsWith('/auth/login')) return btoa(currentUrl);
  return '';
};
